import { Injectable } from '@angular/core';

@Injectable()
export class WindowService {
    redirect(url: string): void {
        window.location.href = url;
    }
}
